import { useContext } from "react";
import { Button, Callout } from "@blueprintjs/core";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { WorkbenchContext } from "@pages/editor/providers";

import { CleanDialog, DialogActions, DialogBody } from "./RuleShareUtils";

interface Props {
  // user is either switching from unlisted to private or vice versa
  isSwitchToPrivate: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const SwitchToUnlistedWarning = (
  <Callout intent="warning" title="Confirm to make this rule public">
    <p>Anyone will access this rule if they have the link.</p>
  </Callout>
);

const SwitchToPrivateWarning = (
  <Callout intent="warning" title="Confirm to make this rule private">
    <p>Users outside your organization will no longer access this rule.</p>
  </Callout>
);

export const ConfirmVisibilitySwitchDialog: React.FC<Props> = ({
  isSwitchToPrivate,
  onConfirm,
  onCancel,
}) => {
  const { workbench } = useContext(WorkbenchContext);
  return (
    <CleanDialog
      isOpen={true}
      onClose={workbench.ui.closeRuleShareDialog}
      title={`Switch to ${isSwitchToPrivate ? "private" : "public"}`}
    >
      <DialogBody>
        {isSwitchToPrivate ? SwitchToPrivateWarning : SwitchToUnlistedWarning}
        <DialogActions>
          <Button intent="none" onClick={onCancel}>
            Cancel
          </Button>
          <Button intent="primary" onClick={onConfirm}>
            <FontAwesomeIcon icon={faCheckCircle} /> Confirm
          </Button>
        </DialogActions>
      </DialogBody>
    </CleanDialog>
  );
};
